import { useEffect, useState } from 'react'

import { ScreenSize } from '../types'
import { getScreenSize } from '../utils'

/**
 * The current screen size band, kept current as the window is resized.
 *
 * `getScreenSize()` on its own is a reading taken once; a component that lays out differently at
 * different widths has to be told when the reading changes, or it keeps the layout it mounted with
 * until something else happens to re-render it. Class components do this with their own resize
 * listener — this is the same thing for the ones that can hold a hook.
 */
export default function useScreenSize(): ScreenSize {
	const [screenSize, setScreenSize] = useState<ScreenSize>(getScreenSize)

	useEffect(() => {
		const onResize = () => setScreenSize(getScreenSize())

		addEventListener('resize', onResize)

		// A resize between the first render and this effect running would otherwise be missed.
		onResize()

		return () => removeEventListener('resize', onResize)
	}, [])

	return screenSize
}
